<script setup></script>
<template>
	<section class="collaboration section" id="collaboration">
		<div class="container">
			<h2 class="collaboration__title title2">Коллаборация</h2>
			<div class="collaboration__texts">
				<h5 class="collaboration__subtitle">Великое искусство в музее и на вашей кухне</h5>
				<p>О коллаборации бренда «Мистраль» и Третьяковской галереи</p>
			</div>
			<div class="collaboration__container">
				<div class="collaboration-item">
					<div class="collaboration-item__contente">
						<h4 class="collaboration-item__title">От крупинки до шедевра</h4>
						<div class="collaboration-item__desc">
							<p>С брендом «Мистраль» можно воплотить любые кулинарные идеи, ведь мы уже отобрали лучшие сорта риса, круп и бобовых из разных уголков планеты.</p>
							<p>
								А вы когда-нибудь задумывались, что приготовление блюд - тоже великое искусство? Как и в живописи, здесь требуется мастерство, креативность и внимание к деталям. Каждый ингредиент, как цвет на палитре художника, вносит свой вклад в конечный шедевр. И как нам всем известно, великие
								шедевры достойны места в музее.
							</p>
						</div>
					</div>
					<div class="collaboration-item__image">
						<img class="full-img" width="578" height="400" src="@/assets/img/collaboration/collaboration_img_1.webp" alt="изображение" />
					</div>
				</div>
				<div class="collaboration-item">
					<div class="collaboration-item__contente">
						<h4 class="collaboration-item__title">Культурное наследие</h4>
						<div class="collaboration-item__desc">
							<p>Мы задали себе вопрос: «Если бы бренд был музеем, то каким?»</p>
							<p>
								Третьяковская Галерея — поистине народный музей. Картины, которые знает каждый еще с детства. Полотна Васнецова, Левитана, Малевича не просто висят на стенах, они восхищают, поражают и вдохновляют. Так же, как и наши крупы становятся неотъемлемой частью кухни, общих традиций и семейных
								историй.
							</p>
						</div>
					</div>
					<div class="collaboration-item__image">
						<img class="full-img" width="578" height="400" src="@/assets/img/collaboration/collaboration_img_2.webp" alt="изображение" />
					</div>
				</div>
				<div class="collaboration-item">
					<div class="collaboration-item__contente">
						<h4 class="collaboration-item__title">Искусство не может быть только в залах музея.</h4>
						<div class="collaboration-item__desc">
							<p>
								Искусство должно быть везде. В зернышке риса, в крупинке гречки, в каждом тщательно подобранном ингредиенте. Поэтому коллаборации «Мистраль» и Третьяковской галереи - это не просто рекламная кампания, не просто дизайн упаковки. Это диалог культур, диалог поколений, диалог вкусов.
								Настоящий культурный опыт, который подарит массу положительных эмоций и вдохновит на новые свершения.
							</p>
						</div>
					</div>
				</div>
			</div>
		</div>
	</section>
</template>
<style lang="scss" scoped>
@use "@/assets/scss/base/vars";
.collaboration {
	background-image: url("@/assets/img/collaboration/collaboration_lline_top.webp"), url("@/assets/img/collaboration/collaboration_lline_bottom.webp");
	background-repeat: no-repeat;
	background-position: 104% 29%, 0% 108%;
	background-size: 65rem 97rem, 66rem 95rem;
	@media (max-width: vars.$l) {
		background-position: 104% 29%, 0% 91%;
	}
	@media (max-width: vars.$t) {
		background-size: 65rem 97rem, 45rem 82rem;
	}
	@media (max-width: vars.$mn) {
		background-image: none;
	}
}
.collaboration__title {
	@media (max-width: vars.$x480) {
		margin-bottom: 2.1rem;
	}
}
.collaboration__texts {
	display: flex;
	align-items: center;
	flex-direction: column;
	margin-left: auto;
	margin-right: auto;
	gap: 1.7rem;
	margin-bottom: 5.4rem;
	max-width: 77rem;
	@media (max-width: vars.$x480) {
		gap: 1.3rem;
		margin-bottom: 3.5rem;
		max-width: 31rem;
	}
	p {
		font-weight: 400;
		font-size: 2.4rem;
		line-height: 140%;
		text-align: center;
		@media (max-width: vars.$x480) {
			font-weight: 400;
			font-size: 1.6rem;
		}
	}
}
.collaboration__subtitle {
	font-weight: 500;
	font-size: 3.2rem;
	line-height: 120%;
	text-align: center;
	@media (max-width: vars.$x480) {
		font-size: 2rem;
	}
}
.collaboration__container {
	display: grid;
	gap: 9.2rem;
	padding: 0 11rem;
	@media (max-width: vars.$l) {
		padding: 0;
	}
	@media (max-width: vars.$x480) {
		gap: 72px;
	}
}
.collaboration-item {
	display: flex;
	align-items: center;
	gap: 8rem;
	@media (max-width: vars.$m) {
		flex-direction: column;
	}
	@media (max-width: vars.$x480) {
		gap: 24px;
	}
	&:nth-child(2) {
		flex-direction: row-reverse;
		@media (max-width: vars.$m) {
			flex-direction: column;
		}
	}
	&:nth-child(3) {
		justify-self: center;
		padding: 3rem 0 0 16rem;
		@media (max-width: vars.$mn) {
			padding: 0;
		}
		.collaboration-item__contente {
			padding-right: 0;
			max-width: 88rem;
			@media (max-width: vars.$m) {
				max-width: 100%;
			}
		}
		.collaboration-item__desc {
			max-width: 66.4rem;
			@media (max-width: vars.$m) {
				max-width: 100%;
			}
		}
	}
}
.collaboration-item__contente {
	padding-right: 6rem;
	@media (max-width: vars.$l) {
		padding-right: 0;
	}
}
.collaboration-item__title {
	font-weight: 500;
	font-size: 3.2rem;
	line-height: 120%;
	color: #0c4ca3;
	margin-bottom: 2rem;
	@media (max-width: vars.$x480) {
		font-size: 2rem;
		margin-bottom: 12px;
	}
}
.collaboration-item__desc {
	font-weight: 400;
	font-size: 2rem;
	line-height: 160%;
	text-align: justify;
	@media (max-width: vars.$x480) {
		font-size: 1.6rem;
		line-height: 140%;
	}
	p {
		&:not(:last-child) {
			margin-bottom: 3rem;
			@media (max-width: vars.$x480) {
				margin-bottom: 2rem;
			}
		}
	}
}
.collaboration-item__image {
	overflow: hidden;
	border-radius: var(--border-radius);
	width: 57.8rem;
	flex-shrink: 0;
	@media (max-width: vars.$mn) {
		width: 48%;
	}
	@media (max-width: vars.$m) {
		width: 90%;
	}
	@media (max-width: vars.$xx) {
		width: 100%;

	}
	img {
		aspect-ratio: 289 / 200;
	}
}
</style>
